"use strict";

document.addEventListener('DOMContentLoaded', function () {
  const tableContents = document.querySelector('.table-contents__list');
  const buttonTableContents = document.querySelector('.table-contents__button');

  if(tableContents) {
    window.addEventListener('resize', () => {
      if(window.outerWidth >= 1050) {
        buttonTableContents.classList.remove('table-contents__button--opened');
        tableContents.removeAttribute('style');
      }
    });
  }

  if(buttonTableContents) {
    buttonTableContents.addEventListener('click', () => {
      if(document.body.clientWidth < 1050) {
        buttonTableContents.classList.toggle('table-contents__button--opened');
        slideToggle(buttonTableContents.nextElementSibling);
      }
    });
  }

  const header = document.querySelector('header');
  const linksTableContents = document.querySelectorAll('.table-contents__link');
  if(linksTableContents) {
    linksTableContents.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const link = item.getAttribute('href');
        const blockID = link.substring(link.indexOf('#'));
        const elID = document.querySelector(blockID);
        let topOffset = header.offsetHeight + 12;
        const elementPosition = elID.getBoundingClientRect().top;
        const offsetPosition = elementPosition - topOffset;
  
        window.scrollBy({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    });
  }
});